import React, { useEffect, useState } from 'react';
import { Menu, Phone, X } from 'lucide-react';
import { Button } from './ui/Button';
import { navLinks, site } from '../data/site';
export function SiteHeader() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${scrolled ? 'border-b border-ink-600/60 bg-ink/95 backdrop-blur-md' : 'border-b border-white/10 bg-ink/60 backdrop-blur-sm'}`} data-id="element-185" data-mp="qxysj05qkd7f">
      <div className="mx-auto flex h-20 max-w-[1400px] items-center gap-8 px-6 lg:px-10" data-id="element-186" data-mp="2gbbqm7n99503">
        <a href="#top" className="flex shrink-0 items-center" aria-label={`${site.name} — home`} data-id="element-187" data-mp="2bch9da4xroi3">
          <img src={site.logo} alt={site.name} width={2189} height={729} loading="eager" decoding="async" className="h-9 w-auto invert md:h-11" data-id="element-188" data-mp="29jty0q0tskkb" />
        </a>

        <nav className="ml-auto hidden items-center gap-9 lg:flex" aria-label="Primary" data-id="element-189" data-mp="2jjb06xgvcgbj">
          {navLinks.map(link => <a key={link.href} href={link.href} className="font-mono text-[11px] uppercase tracking-[0.22em] text-ivory/70 transition-colors hover:text-brass-light" data-id="element-190" data-mp="2of03nbw0ehd4">
              {link.label}
            </a>)}
        </nav>

        <div className="ml-auto flex items-center gap-3 lg:ml-0" data-id="element-191" data-mp="20q73f38ctncp">
          <a href={`tel:${site.phone.replace(/[^0-9]/g, '')}`} className="hidden items-center gap-2 font-mono text-[11px] uppercase tracking-[0.18em] text-ivory/70 transition-colors hover:text-brass-light md:flex" data-id="element-192" data-mp="25ja0hlccbexn">
            <Phone className="h-3.5 w-3.5" aria-hidden="true" data-id="element-193" data-mp="1czl17sl16xam" />
            {site.phone}
          </a>
          <Button asChild className="h-11 rounded-none bg-brass px-6 font-mono text-[11px] uppercase tracking-[0.2em] text-ink hover:bg-brass-light" data-id="element-194" data-mp="10250yvowr9tb">
            <a href="#contact" data-id="element-195" data-mp="1et4965ltzwcd">Book a Visit</a>
          </Button>
          <button type="button" onClick={() => setOpen(v => !v)} className="flex h-11 w-11 items-center justify-center border border-white/15 text-ivory lg:hidden" aria-expanded={open} aria-controls="mobile-nav" aria-label={open ? 'Close menu' : 'Open menu'} data-id="element-196" data-mp="19t9dlor42ikz">
            {open ? <X className="h-5 w-5" data-id="element-197" data-mp="r1gpa7mzlljl" /> : <Menu className="h-5 w-5" data-id="element-198" data-mp="r173yxcw02k8" />}
          </button>
        </div>
      </div>

      {open && <nav id="mobile-nav" className="border-t border-white/10 bg-ink px-6 pb-6 pt-2 lg:hidden" aria-label="Mobile" data-id="element-199" data-mp="27enken6fovrc">
          {navLinks.map(link => <a key={link.href} href={link.href} onClick={() => setOpen(false)} className="block border-b border-white/5 py-4 font-display text-2xl text-ivory" data-id="element-200" data-mp="29zv8rpxyel2a">
              {link.label}
            </a>)}
          <a href={`tel:${site.phone.replace(/[^0-9]/g, '')}`} className="mt-5 block font-mono text-xs uppercase tracking-[0.2em] text-brass-light" data-id="element-201" data-mp="250ifonghohr9">
            {site.phone}
          </a>
        </nav>}
    </header>;
}